<template>
	<div />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'AnalyticsPopup',
	computed: {
		...mapGetters({
			shouldShowPopup: 'analytics-popup/shouldShowPopup'
		})
	},

	mounted () {
		// Show popup after a short delay to ensure page is loaded
		if (this.shouldShowPopup) {
			setTimeout(() => {
				this.$modal.open('ModalAnalyticsPopup')
			}, 1000)
		}
	}
}
</script>
